var $016788a043bfb866$exports = {};
$016788a043bfb866$exports = {
    "maximum": `\u{CD5C}\u{B300}`,
    "minimum": `\u{CD5C}\u{C18C}`
};


export {$016788a043bfb866$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
